<template>
    <div id="menuHeaderPlano" class="flexContainer ai-c jc-sb m-jc-sb m-fd-r">
        <button
            id="cancelPlano"
            class="btn cancel pointer mobileNot tabletNot"
            v-if="showButton === true && lock === 'false' && allows === 'true'"
            @click="cancel('cancel');"
        >
            <img class="return" src="../../../static/img/returnBtn.png" alt="" /> {{ $t("headerPlano.cancel") }}
        </button>
        <button id="return" class="btn cancel pointer mobileNot tabletNot" v-if="lock === 'true' || allows === 'false'" @click="cancel('retour');">
            <img class="return" src="../../../static/img/returnBtn.png" alt="" />{{ $t("headerPlano.back") }}
        </button>
        <button id="returnMobile" class="btn cancel mobileOnly" @click="cancel('retour');">
            <img class="return" src="../../../static/img/returnBtn.png" alt="" />
        </button>
        <button id="saveModule" v-if="!showButton" @click="closeModule('cancel');" class="pointer btn pointer">
            <img class="return" src="../../../static/img/returnBtn.png" alt="" />{{ $t("planobuilder.cancelShades") }}
        </button>
        <div class="planoInfo" :class="{ moduleMode: showButton === false }">
            <div>
                <p class="title ff-medium">{{ planoDetail.name }}</p>
                <p class="titleBy ff-light">
                    {{ $t("planobuilder.by") }} {{ userCreated.firstname ? userCreated.firstname : "" }} {{ userCreated.lastname }}
                    <span class="mobileNot">-</span> <br class="mobileOnly" />
                    {{ $t("planobuilder.modifiedBy") }} {{ modifiedUser.firstname }} {{ modifiedUser.lastname }} {{ $t("planobuilder.on") }}
                    {{ modifiedUser.date }}
                </p>
            </div>
            <div class="campaignName">
                <p class="title ff-medium uppercase">
                    {{ planoDetail.campaign ? planoDetail.campaign.name : "" }} - {{ planoDetail.zone ? planoDetail.zone.name : "" }}
                </p>
            </div>
        </div>
        <button id="cancelModule" v-if="!showButton" @click="closeModule('save');" class="btn uppercase pointer">
            {{ $t("planobuilder.saveShades") }}
        </button>
        <div id="savePlano">
            <button
                v-if="showButton === true && this.lock === 'false' && allows === 'true'"
                class="btn save pointer mobileNot"
                id="saveOnly"
                @click="save('save');"
            >
                {{ $t("headerPlano.save") }}
            </button>
            <button
                v-if="showButton === true && this.lock === 'false' && allows === 'true'"
                class="btn saveExit pointer mobileNot"
                id="saveExit"
                @click="save('saveExit');"
            >
                {{ $t("headerPlano.saveExit") }}
            </button>
        </div>
    </div>
</template>
<script>
import { builderMixin } from "../planoold/mixins/builder";
import httpService from "../service";
import { mapGetters } from "vuex";
import { bus } from "../../main";
import { i18n } from "../../main.js";
import cacheService from "@/services/cache";

export default {
    mixins: [builderMixin],
    data: () => ({
        showButton: true,
        planoId: "",
        planoDetail: {},
        userCreated: {},
        lock: "",
        modifiedUser: {},
        selectedCampaign: cacheService.getCurrentCampaignId(),
        access: "",
        allows: ""
    }),
    watch: {
        retMode: function(val) {
            if (val === "module") {
                this.showButton = false;
            } else {
                this.showButton = true;
            }
        },
        retModifiedDate: function(val) {
            this.modifiedUser = val;
        }
    },
    methods: {
        cancel(a) {
            let self = this;
            if (a === "retour") {
                self.$router.push({ name: "Planos", query: self.getLinkParams({ campaign: self.selectedCampaign }) });
            } else if (a === "cancel") {
                let confirmTitle;
                let warningText;
                let confirmDelete;
                if (i18n.locale === "fr") {
                    confirmTitle = "Sortir du planogramme ?";
                    warningText = "Etes-vous de vouloir quitter ? Vos changements ne seront pas pris en compte!";
                    confirmDelete = "Oui, quitter!";
                } else if (i18n.locale === "en") {
                    confirmTitle = "Close this planogramme ?";
                    warningText = "Are you sure? You won't be able to revert the changes!";
                    confirmDelete = "Yes, close it!";
                }
                this.$swal({
                    title: confirmTitle,
                    text: warningText,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: confirmDelete,
                    closeOnConfirm: true
                }).then(result => {
                    if (result === true) {
                        httpService.post("/plano/" + this.$route.params.id + "/back").then(response => {
                            self.$store.state.plano.status.builder.groups = [];
                            self.$router.push({ name: "Planos", query: self.getLinkParams({ campaign: self.selectedCampaign }) });
                        });
                    } else {
                    }
                });
            }
        },
        closeModule(a) {
            bus.$emit("groupeditor_closeModule", a);
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }

            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        }
    },
    computed: {
        ...mapGetters({
            getPlanoDetails: "plano/data/getPlanoDetails",
            getMeuble: "plano/data/getMeuble",
            getGroups: "plano/status/getGroups"
        }),
        retMode() {
            return this.$store.state.plano.status.builder.mode;
        },
        retModifiedDate() {
            return this.$store.state.plano.status.builder.modifiedUser;
        }
    },
    mounted() {},
    created() {
        this.$store.dispatch("plano/data/getMeuble", { id: this.$route.params.id }).then(() => {
            this.planoDetail = this.getPlanoDetails;
            this.userCreated = this.getPlanoDetails.createdUser;
            let user = cacheService.getRem3rchUser();
            if (
                user.user.firstname === this.getPlanoDetails.modifiedUser.firstname &&
                user.user.lastname === this.getPlanoDetails.modifiedUser.lastname
            ) {
                this.access = true;
            } else {
                this.access = false;
            }
            cacheService.set("planoAccess", this.access);
        });
        this.lock = cacheService.get("planoLocked");
        this.allows = cacheService.get("planoAccess");
        this.modifiedUser = {
            firstname: this.getPlanoDetails.modifiedUser.firstname,
            lastname: this.getPlanoDetails.modifiedUser.lastname,
            date: this.getPlanoDetails.modifiedUser.modifiedDate
        };
    }
};
</script>
<style scoped lang="scss">
.moduleMode {
    margin: 0 auto;
}
.campaignName {
    font-size: 12px;
}
.cancel {
    text-decoration: none;
    color: white;
}
#menuHeaderPlano {
    position: relative;
    height: 63px;
    background-color: black;
    color: white;
    padding: 0 50px;
    .txtCenter {
        line-height: 1px;
        color: white;
        font-family: Roboto;
    }
}
.cancel {
    color: white;
    border: 1px solid white;
    padding-left: 10px;
}
.save {
    color: white;
    border: 1px solid white;
}
.saveExit {
    color: white;
    border: 1px solid white;
    margin-left: 15px;
}
.return {
    padding-right: 10px;
    padding-bottom: 3px;
}
#cancelModule,
#saveModule {
    color: #fff;
    border: 1px solid #fff;
}
.titleBy {
    font-family: "Oswald", Sans-Serif;
    font-size: 9px;
}
.title {
    font-family: "Oswald", Sans-Serif;
    font-size: 12px;
}
@media only screen and (max-width: 767px) {
    #returnMobile {
        margin-right: 20px;
        .return {
            padding: 0;
            position: relative;
            left: 3px;
            bottom: 2px;
        }
    }
    #menuHeaderPlano {
        padding: 0 15px;
    }
    .planoInfo {
        width: 100%;
        p {
            margin: 0;
            font-size: 11px;
        }
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    button {
        font-size: 1.2rem;
    }
    #returnMobile {
        margin-right: 20px;
        .return {
            padding: 0;
            position: relative;
            left: 3px;
            bottom: 2px;
        }
    }
    #menuHeaderPlano {
        padding: 0 15px;
    }
    .planoInfo {
        width: 50%;
        p {
            margin: 0;
            font-size: 11px;
        }
    }
    #savePlano {
        display: flex;
    }
}
</style>



// WEBPACK FOOTER //
// MenuHeaderPlano.vue?fcaedb7a